import _kebabCase from 'lodash/kebabCase';
import { IconNames } from '@shipengine/giger-theme';
import { ServiceSortingOptions } from '../types/types.js';

/**
 * In case Service excels use wrong icons names.
 * is the tool that nobody wants but everyone needs
 */

const checkIconName = icon => {
  const legacyIconResolver = {
    'no-printer': IconNames.PRINTER_DISABLED,
    'cash-on-delivery': IconNames.CASH,
    insurance: IconNames.SHIELD,
    dropoff: IconNames.MARKER,
    palet: IconNames.PALLET,
    'no-cash-on-delivery': IconNames.CASH_DISABLED,
    time: IconNames.HOURGLASS,
    box: IconNames.CARDBOARD_BOX_CHECK
  };
  return legacyIconResolver[icon] || icon;
};
const getCarrierLogo = (cdnUrl, logoid) => {
  return `${cdnUrl}/apps/carrier-logos/${logoid}.svg`;
};
const buildSortOptionKey = (option, t) => {
  return t(`service-list.sort-select.option-${option === ServiceSortingOptions.TAGGED_SERVICES ? 'default' : _kebabCase(option)}`);
};

export { buildSortOptionKey, checkIconName, getCarrierLogo };
//# sourceMappingURL=Icon.js.map
